

<mat-tree #tree [dataSource]="treeData" [treeControl]="treeControl" class="layer-list">
  <!-- This is the tree node template for leaf nodes -->
  <!-- There is inline padding applied to this node using styles.
    This padding value depends on the mat-icon-button width. -->
  <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
    <div class="selected-mask" *ngIf="IsSelected(node)" [style.marginLeft]="GetToolsMargin(node)"></div>
    <div class="mat-tree-node child-less" [class.selected]="IsSelected(node)">
      <div class="input-group">
        <div class="caret"></div>
        <ng-container [ngTemplateOutlet]="titleRow" [ngTemplateOutletContext]="{node:node}"></ng-container>
      </div>
      <ng-container [ngTemplateOutlet]="tools" [ngTemplateOutletContext]="{node:node}"></ng-container>
    </div>
  </mat-tree-node>
  <!-- This is the tree node template for expandable nodes -->
  <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [class.tree-top]="IsTopRoute(node)">
    <div class="selected-mask" *ngIf="IsSelected(node)" [style.marginLeft]="GetToolsMargin(node)"></div>

    <div class="mat-tree-node" [class.selected]="IsSelected(node)">
      <div class="input-group">
        <button  *ngIf="!IsRoot(node)" class="btn btn-sm caret" (click)="ToggleNode(node)">
          <span class="fas" [class.fa-caret-right]="!treeControl.isExpanded(node)"></span>
          <span class="fas" [class.fa-caret-down]="treeControl.isExpanded(node)"></span>
        </button>
        <ng-container [ngTemplateOutlet]="titleRow" [ngTemplateOutletContext]="{node:node}"></ng-container>

      </div>
      <ng-container [ngTemplateOutlet]="tools" [ngTemplateOutletContext]="{node:node}"></ng-container>
    </div>
    <!-- There is inline padding applied to this div using styles.
          This padding value depends on the mat-icon-button width.  -->
    <div role="group" [class.hidden]="!treeControl.isExpanded(node)">
      <ng-container matTreeNodeOutlet></ng-container>
    </div>
  </mat-nested-tree-node>
</mat-tree>
<ng-template #titleRow let-node="node">
  <input *ngIf="IsNotRoot(node)" [ngModel]="IsNodeVisible(node)" (ngModelChange)="SetNodeVis(node,$event)" type="checkbox"
    [class.hidden]="isMoving">
  <button (click)="MoveTo(node.id)" *ngIf="IsMoveTarget(node.id)" class="btn btn-sm move-target">
    <span class="fas fa-arrow-alt-circle-down"></span></button>
  <label  [class.root-node]="IsRoot(node)" [title]="GetFullName(node)"><span class="has-selections" *ngIf="HasSelectedFeature(node)">*</span>{{node.name}}</label>
  <div class="the-rest" *ngIf="IsSelected(node)">
    <button [class.hidden]="IsRoot(node)" [class.disabled]="!ShowTool(node,'move-up')" type="button" class="btn btn-primary btn-sm button-up"
      (click)="Move(node.id,'up')">
      <span class="fas fa-caret-up"></span>
    </button>
    <button [class.hidden]="IsRoot(node)" [class.disabled]="!ShowTool(node,'move-down')" type="button" class="btn btn-primary btn-sm button-down"
      (click)="Move(node.id,'down')">
      <span class="fas fa-caret-down"></span>
    </button>

  </div>
</ng-template>

<ng-template #tools let-node="node">
  <div class="tools" [style.marginLeft]="GetToolsMargin(node)" [style.width]="GetToolsWidth(node)">
    <ng-container *ngIf="IsSelected(node)">
      <button *ngIf="ShowTool(node,'config')" (click)="Config(node)" class="config-route-btn btn btn-sm btn-primary"><span
          class="fas fa-cog"></span></button>
      <button [class.active]="IsMoveActive(node.id)" (click)="ToggleMoving(node.id)" *ngIf="ShowTool(node,'move')"
        class="btn btn-sm btn-primary">
        <span class="move-icon fas fa-arrows"></span>
      </button>
      <button *ngIf="ShowTool(node,'jump-to')" (click)="CenterOnRoute(node.id)" class="btn btn-sm btn-primary"><span
          class="fas zoom-to-icon fa-crosshairs"></span></button>
      <button *ngIf="ShowTool(node,'delSelVertex')" (click)="DeleteSelected(node.id)" class="btn btn-sm btn-danger">
        <div class="del-vertex-icon">
          <span class="bottom fas fa-square"></span>
          <span class="top fas fa-slash"></span>
        </div>
      </button>
      <button (click)="DeleteAll(node.id)" title="Delete all points and segments for this route (not subroutes)." *ngIf="ShowTool(node,'delVertices')" class="btn btn-sm btn-danger">
        <div class="del-route-icon">
          <span class="bottom fas fa-slash"></span>
          <span class="top fas fa-vector-square"></span>
        </div>
      </button>

      <button *ngIf="ShowTool(node,'add')" class="btn btn-sm btn-primary" (click)="Add(node)">
        <span class="fas fa-code-branch split"></span>
      </button>
      <button class="btn btn-sm btn-primary" title="Connect selection to another point or segment on any route"
        *ngIf="ShowTool(node,'branch-merge')"[class.merging]="IsMerging(node.id)" (click)="StartBranchMerge()">
        <span class="fas fa-code-branch merge"></span>
      </button>
      <button class="btn btn-sm btn-primary" (click)="GPSUpdate(node.id)" *ngIf="ShowTool(node,'gps-update')" title="Update selected point to GPS location">
        <span class="fas fa-map-pin update-loc-icon"></span>
      </button>
      <button class="btn btn-sm btn-primary" (click)="GPSAdd(node.id)" *ngIf="ShowTool(node,'gps-add')" title="Add point at GPS location">
        <span class="fas fa-map-pin"></span>
      </button>

      <div class="the-rest">
        <button *ngIf="ShowTool(node,'delete')" (click)="Delete(node)" class="close-button btn btn-sm btn-danger"><span
            class="fas fa-times close-button-icon"></span></button>
      </div>
    </ng-container>
    <ng-container *ngIf="IsNotSelected(node)">
      <button class="btn-sm btn-primary" (click)="Select(node)"><span class="fas fa-hand-pointer"></span></button>
    </ng-container>
  </div>
</ng-template>
